import { Clock3 } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { formatClock } from "../lib";

export function Timer({
  endsAtMs,
  paused,
  onExpired,
  onUrgentTick,
}: {
  endsAtMs: number | null;
  paused: boolean;
  onExpired?: () => void;
  onUrgentTick?: (secondsRemaining: number) => void;
}) {
  const [seconds, setSeconds] = useState(() => endsAtMs ? (endsAtMs - Date.now()) / 1000 : 0);
  const onExpiredRef = useRef(onExpired);
  const onUrgentTickRef = useRef(onUrgentTick);

  useEffect(() => {
    onExpiredRef.current = onExpired;
  }, [onExpired]);

  useEffect(() => {
    onUrgentTickRef.current = onUrgentTick;
  }, [onUrgentTick]);

  useEffect(() => {
    if (!endsAtMs || paused) return;
    let fired = false;
    let lastUrgentSecond: number | null = null;
    const update = () => {
      const next = Math.max(0, (endsAtMs - Date.now()) / 1000);
      setSeconds(next);
      const wholeSeconds = Math.ceil(next);
      if (wholeSeconds > 0 && wholeSeconds <= 10 && wholeSeconds !== lastUrgentSecond) {
        lastUrgentSecond = wholeSeconds;
        onUrgentTickRef.current?.(wholeSeconds);
      }
      if (next <= 0 && !fired) {
        fired = true;
        onExpiredRef.current?.();
      }
    };
    update();
    const interval = window.setInterval(update, 250);
    return () => window.clearInterval(interval);
  }, [endsAtMs, paused]);

  if (!endsAtMs && !paused) return null;
  return (
    <div className={`timer ${seconds <= 10 ? "timer-danger" : ""}`} role="timer" aria-live={seconds <= 10 ? "polite" : "off"} aria-atomic="true">
      <Clock3 className="size-4" />
      <span>{paused ? "Tạm dừng" : formatClock(seconds)}</span>
    </div>
  );
}
